(function() {
  if (!document.body.className.includes('template-product-ir-inositol')) return;

  function initGalleryLoop() {
    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(function(gallery) {
      if (gallery._irLoopPatched) return;
      gallery._irLoopPatched = true;

      var viewer = gallery.elements ? gallery.elements.viewer : gallery.querySelector('[id^="GalleryViewer"]');
      var thumbnails = gallery.elements ? gallery.elements.thumbnails : gallery.querySelector('[id^="GalleryThumbnails"]');
      if (!viewer) return;

      var viewerPrev = viewer.querySelector('.product-gallery__viewer-nav--prev');
      var viewerNext = viewer.querySelector('.product-gallery__viewer-nav--next');

      function getMediaItems() {
        return Array.from(viewer.querySelectorAll('.product__media-list > .product__media-item[data-media-id]'));
      }

      function getThumbItems() {
        if (!thumbnails) return [];
        return Array.from(thumbnails.querySelectorAll('[id^="Slide-"][data-target]')).filter(function(el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        });
      }

      function getCurrentIndex() {
        var thumbItems = getThumbItems();
        var activeThumb = thumbnails ? thumbnails.querySelector('[data-target] button[aria-current="true"]') : null;
        if (activeThumb) {
          var parentItem = activeThumb.closest('[data-target]');
          var idx = thumbItems.indexOf(parentItem);
          if (idx >= 0) return idx;
        }
        var mediaItems = getMediaItems();
        var idx = mediaItems.findIndex(function(s) { return s.classList.contains('is-active'); });
        return idx < 0 ? 0 : idx;
      }

      function goToIndex(idx) {
        var thumbItems = getThumbItems();
        var mediaItems = getMediaItems();
        var itemCount = thumbItems.length > 0 ? thumbItems.length : mediaItems.length;
        if (itemCount === 0) return;
        if (idx < 0) idx = itemCount - 1;
        if (idx >= itemCount) idx = 0;

        var mediaId;
        if (thumbItems.length > 0 && thumbItems[idx]) {
          mediaId = thumbItems[idx].dataset.target;
        } else if (mediaItems[idx]) {
          mediaId = mediaItems[idx].dataset.mediaId;
        }

        if (mediaId) {
          var targetMedia = viewer.querySelector('[data-media-id="' + mediaId + '"]');
          if (targetMedia) {
            gallery.setActiveMedia(mediaId, false);
          }
        }
      }

      if (viewerPrev && viewerNext) {
        function handleViewerNav(e) {
          var btn = e.target.closest('.product-gallery__viewer-nav');
          if (!btn) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var idx = getCurrentIndex();
          var isNext = btn.classList.contains('product-gallery__viewer-nav--next');
          goToIndex(isNext ? idx + 1 : idx - 1);
        }

        viewer.addEventListener('click', handleViewerNav, true);

        function keepViewerButtonsEnabled() {
          viewerPrev.disabled = false;
          viewerNext.disabled = false;
          viewerPrev.removeAttribute('disabled');
          viewerNext.removeAttribute('disabled');
        }
        gallery.syncViewerNavButtons = keepViewerButtonsEnabled;
        new MutationObserver(keepViewerButtonsEnabled).observe(viewerPrev, { attributes: true, attributeFilter: ['disabled'] });
        new MutationObserver(keepViewerButtonsEnabled).observe(viewerNext, { attributes: true, attributeFilter: ['disabled'] });
        keepViewerButtonsEnabled();
      }

      if (thumbnails) {
        var thumbPrev = thumbnails.querySelector('button[name="previous"]');
        var thumbNext = thumbnails.querySelector('button[name="next"]');
        var thumbSlider = thumbnails.querySelector('[id^="Slider-"]');

        if (thumbPrev && thumbNext && thumbSlider) {
          function handleThumbNav(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var items = getThumbItems();
            if (items.length < 2) return;

            var isNext = e.currentTarget.name === 'next';
            var currentIdx = getCurrentIndex();
            var nextIdx = isNext ? currentIdx + 1 : currentIdx - 1;
            if (nextIdx >= items.length) nextIdx = 0;
            if (nextIdx < 0) nextIdx = items.length - 1;

            var targetItem = items[nextIdx];
            if (targetItem) {
              var mediaId = targetItem.dataset.target;
              gallery.setActiveMedia(mediaId, false);

              var targetLeft = targetItem.offsetLeft;
              var sliderWidth = thumbSlider.clientWidth;
              var scrollTarget = targetLeft - (sliderWidth / 2) + (targetItem.offsetWidth / 2);
              thumbSlider.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
            }
          }

          thumbPrev.addEventListener('click', handleThumbNav, true);
          thumbNext.addEventListener('click', handleThumbNav, true);

          function keepThumbButtonsEnabled() {
            thumbPrev.disabled = false;
            thumbNext.disabled = false;
            thumbPrev.removeAttribute('disabled');
            thumbNext.removeAttribute('disabled');
          }
          new MutationObserver(keepThumbButtonsEnabled).observe(thumbPrev, { attributes: true, attributeFilter: ['disabled'] });
          new MutationObserver(keepThumbButtonsEnabled).observe(thumbNext, { attributes: true, attributeFilter: ['disabled'] });
          keepThumbButtonsEnabled();
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalleryLoop);
  } else {
    initGalleryLoop();
  }
  setTimeout(initGalleryLoop, 500);
  setTimeout(initGalleryLoop, 1000);
})();
